import React from 'react';
import {
  Box,
  Paper,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Toolbar,
  Typography,
} from '@mui/material';
import DocumentsTableHead from './DocumentsTableHead';

function DocumentsSkeleton() {
  return (
    <Box>
      <Stack direction="row" alignItems="center" mb={3}>
        <Typography variant="pageTitle">Documents</Typography>
        <Skeleton variant="circular" width={20} height={20} sx={{ ml: 1 }} />
      </Stack>

      <Paper>
        <Toolbar
          className="border-bottom"
          sx={{
            px: 0,
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            width: '100%',
          }}
        >
          <Box sx={{ pt: 2, ml: '-14px' }}>
            <Skeleton variant="circular" width={32} height={32} />
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 2,
              mb: { xs: 2, sm: 2, lg: 0 },
              alignItems: 'center',
            }}
          >
            <Skeleton variant="rectangular" width={200} height={40} sx={{ borderRadius: 1 }} />
          </Box>
        </Toolbar>

        <TableContainer sx={{ overflowX: 'auto' }}>
          <Table sx={{ tableLayout: 'fixed', minWidth: 650 }}>
            <DocumentsTableHead />

            <TableBody>
              {Array.from({ length: 3 }).map((_, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Stack direction="row" gap={2} alignItems="center">
                      <Skeleton animation="wave" variant="circular" width={24} height={24} />
                      <Skeleton animation="wave" variant="text" width="60%" height={24} />
                    </Stack>
                  </TableCell>
                  <TableCell>
                    <Skeleton animation="wave" variant="text" width="80%" height={24} />
                  </TableCell>
                  <TableCell>
                    <Skeleton animation="wave" variant="text" width="70%" height={24} />
                  </TableCell>
                  <TableCell align="right" sx={{ pr: 2 }}>
                    <Stack direction="row" gap={1} justifyContent="flex-end">
                      <Skeleton animation="wave" variant="circular" width={20} height={20} />
                      <Skeleton animation="wave" variant="circular" width={20} height={20} />
                      <Skeleton animation="wave" variant="circular" width={20} height={20} />
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
}

export default DocumentsSkeleton;
